export default __webpack_public_path__ + "static/media/gong.208236e9.jpg";